// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReport.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var constants = require('logic/data/Izenda.ReportDesignerConstants');
  var subReportConstant = require('logic/data/Izenda.PropertiesBuilderConstants').SUB_REPORT;

  const { isNil, pluck, map, compact, flow, set, find } = require('lodash/fp');

  var CALCULATED_FIELD_CATE_NAME = 'Calculated Fields';

  function SubReport() {
    this.ADD_MAPPING_FIELD_BUTTON = 'addMappingField';

    var props = {
      fieldInCurrentReportPart: [],
      fieldInSubReport: [],
      gridData: [],
      reportParts: [],
      selectedReport: null,
      style: constants.DRIL_DOWN_STYLE.LINK_NEW_WINDOW,
      reportPartUsed: null,
      reportFilter: true,
      viewSettingByLink: true,
      selectedReportName: null,
      selectedIconValue: {
        icon: subReportConstant.DEFAULT_ICON.icon,
        value: subReportConstant.DEFAULT_ICON.value
      }
    };

    m.extendObservable(this, props);
  }

  /**
   * Read initial data from props
   * @param {Object} data
   */
  SubReport.prototype.readInitialData = m.action(function(data, hideViewSetting) {
    data = data || {};
    var viewSettingByLink = !isNil(data.viewSettingByLink) ? !!data.viewSettingByLink : true;
    var selectedIconValue = data.selectedIconValue;

    this.selectedReport = data.selectedReport;
    this.style = data.style || constants.DRIL_DOWN_STYLE.LINK_NEW_WINDOW;
    this.reportPartUsed = data.reportPartUsed || null;
    this.gridData = data.mappingFields && m.toJS(data.mappingFields);
    this.reportFilter = data.reportFilter;
    if (selectedIconValue && !isNil(selectedIconValue.icon) && !isNil(selectedIconValue.value)) {
      this.selectedIconValue = selectedIconValue;
    }
    this.viewSettingByLink = hideViewSetting ? true : viewSettingByLink;
  });

  /**
   * Read list Reports, field in current report from API
   * @param {Object} data
   */
  SubReport.prototype.readReports = m.action(function(data) {
    this.selectedReportName = data.reportData.name;
    this.fieldInCurrentReportPart = data.fieldInCurrentReportPart;
    this.readSubReport(data);
    this.populateReportsListData();
  });

  /**
   * [populateReportsListData function is to set up data when the report list have no category will store in group
   * named 'Uncategorized'
   * @param  {[type]}
   * @return {[type]}         return report list data
   */
  SubReport.prototype.populateReportsListData = m.action(function() {
    map(function(report) {
      if (!report.name && report.id === subReportConstant.UNDEFINED) {
        report.name = subReportConstant.UNCATEGORIZED;
      }
    }, this.reports);
  });

  /**
   * Read list fields in sub report from API
   * @param {Object} data
   */
  SubReport.prototype.readSubReport = m.action(function(data) {
    this.fieldInSubReport = map(function(field) {
      var valueId = compact([field.relationshipId, field.querySourceFieldId]).join('_');
      var fieldNameInSubReport = String.format('[{0}]', field.sourceFieldName);

      // if this field is Calculated field don't need to add source data object name
      if (!(field.isCalculated && field.querySourceType === CALCULATED_FIELD_CATE_NAME)) {
        fieldNameInSubReport = String.format('[{0}].{1}', field.sourceDataObjectName, fieldNameInSubReport);

        if (!field.relationshipId && field.connectionName && field.querySourceCategoryName) {
          fieldNameInSubReport = String.format(
            '[{0}].[{1}].{2}',
            field.connectionName,
            field.querySourceCategoryName,
            fieldNameInSubReport
          );
        }
      }

      return flow(set('id', valueId), set('fieldNameInSubReport', fieldNameInSubReport))(field);
    }, data.fieldInSubReport || []);
    this.reportParts = data.reportData.reportPart || [];
  });

  /**
   * Update selected report
   * @param {String} reportId
   */
  SubReport.prototype.updateSelectedReport = m.action(function(report) {
    this.selectedReport = report.id || null;
    this.selectedReportName = report.name || null;
    // Clear mappings
    this.gridData.clear();
  });

  /**
   * Update Style
   * @param {String} value
   */
  SubReport.prototype.updateStyle = m.action(function(value) {
    this.style = value;
  });

  /**
   * Update Report Part
   * @param {String} value
   */
  SubReport.prototype.updateReportPart = function(reportParts) {
    var reportPartUsed = pluck('id', reportParts).toString();

    if (reportParts && reportParts.indexOf(subReportConstant.ALL_OPTION) > -1) {
      reportPartUsed = 'All';
    }
    this.reportPartUsed = reportPartUsed;
  };

  /**
   * Update Report Filter
   * @param {String} value
   */
  SubReport.prototype.updateReportFilter = m.action(function(value) {
    this.reportFilter = value;
  });

  /**
   * Add mapping field
   */
  SubReport.prototype.addMappingField = m.action(function() {
    this.gridData.push({
      fieldNameAlias: '',
      fieldInSubReport: '',
      relationshipInSubReport: '',
      fieldNameInSubReport: ''
    });
  });

  /**
   * Remove a mapping field
   * @param {number} index
   */
  SubReport.prototype.removeMappingField = function(index) {
    index > -1 && this.gridData.splice(index, 1);
  };

  /**
   * Remove empty field mapping's row
   */
  SubReport.prototype.removeUnusedMappingField = m.action(function() {
    // Filter empty row
    this.gridData = this.gridData.filter(function(item) {
      return item.fieldNameAlias || item.fieldInSubReport || item.relationshipInSubReport;
    });
  });

  /**
   * [updateViewSettingByLink Update the state of view setting link]
   * @param  {[type]} state [description]
   */
  SubReport.prototype.updateViewSettingByLink = m.action(function() {
    this.viewSettingByLink = !this.viewSettingByLink;
  });

  /**
   * [updateSelectedViewSettingIcon]
   * @param  {[type]} value [description]
   */
  SubReport.prototype.updateSelectedViewSettingIcon = m.action(function(value) {
    var selectedIcon = find({ value: value }, subReportConstant.ICON_TYPES);
    if (selectedIcon) {
      this.selectedIconValue = {
        icon: selectedIcon.icon,
        value: selectedIcon.value
      };
    }
  });

  SubReport.prototype.validateDuplicate = function() {
    var duplicateMap = {};
    var duplicateIndex = [];

    m.toJS(this.gridData || []).forEach(function(item, index) {
      var key = [item.fieldNameAlias, item.fieldNameInSubReport].join('_');

      if (duplicateMap[key]) {
        duplicateIndex.push(index);
      } else {
        duplicateMap[key] = true;
      }
    });

    return map(function(item) {
      return {
        key: subReportConstant.SUB_REPORT_GRID.VALIDATOR_GROUP + item,
        messages: [subReportConstant.SUB_REPORT_GRID.DUPLICATE_ERROR_MESSAGE]
      };
    }, duplicateIndex);
  };

  module.exports = SubReport;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SubReport.js